'use client';

import { useAppDispatch } from '@akinon/next/redux/hooks';
import { toggleMobileMenu } from '@akinon/next/redux/reducers/header';
import clsx from 'clsx';
import { Button, Icon } from '@theme/components';

export default function MobileHamburgerButton() {
  const dispatch = useAppDispatch();

  return (
    <Button
      appearance='ghost'
      aria-label="Menüyü Aç"
      className={clsx([
        'size-8',
        'flex items-center justify-center',
        'text-black-100',
        'px-0',
        'border-none',
        'h-auto',
        'hover:bg-transparent',
        'hover:text-black-100',
        'lg:hidden',
      ])}
      onClick={() => dispatch(toggleMobileMenu())}
    >
      <Icon name="hamburger" size={32} className="fill-white" />
    </Button>
  );
}
